import { render, staticRenderFns } from "./mainAdmin.vue?vue&type=template&id=6a76153a&scoped=true&"
import script from "./mainAdmin.vue?vue&type=script&lang=js&"
export * from "./mainAdmin.vue?vue&type=script&lang=js&"
import style0 from "./mainAdmin.vue?vue&type=style&index=0&id=6a76153a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a76153a",
  null
  
)

export default component.exports